import { AxiosInstance } from 'axios';
import { CustomException } from '@core/modules/common/infra/error';
import { BusinessPartnerGateway } from '../domain/business-partner.gateway';
import { BusinessPartnerParams } from '../domain/business-partner.entities';
import { Paths } from './keys';

export class BusinessPartnerHttpGateway implements BusinessPartnerGateway {
    constructor(private http: AxiosInstance) { }

    async getBusinessPartner(params: BusinessPartnerParams): Promise<boolean> {
        try {
            const response = await this.http.get(Paths.default, {
                params: {
                    name: params.name,
                    cnpj: params.cnpj,
                    scheduleId: params.scheduleId,
                    ...(params.address ?? {}),
                },
            });
            
            // Status 200/201 - Tomador encontrado no SAP
            if (response?.status === 200 || response?.status === 201) {
                return Boolean(response?.data);
            }
            return false;
            
        } catch (error: any) {
            // Status 404 - Tomador não encontrado (retornar false, não é erro)
            if (error?.response?.status === 404) {
                return false;
            }
            
            // Outros erros (500, network, etc) - propagar exceção
            throw new CustomException(
                error?.response?.data?.message || 
                'Falha ao consultar tomador PJ no SAP'
            );
        }
    }
}

